import { FieldEntry } from './workforce-form.model';

export class AppointmentWorkforceForm {
	apptId = -2000; // Magic number for 'Other'
	apptStart = '0001-01-01T00:00:00-05:00';
	displayValue = 'Other';
	techId: number;
	fieldEntries = [] as FieldEntry[];

	constructor(init?: Partial<AppointmentWorkforceForm>) {
		Object.assign(this, init);
	}
}
